import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController, Platform } from '@ionic/angular/standalone';
import { Subscription } from 'rxjs';
import { UtilsService } from './utils.service';

const CLOSING_APP_URLS = ['/', '/dashboard'];

@Injectable({
  providedIn: 'root',
})
export class BackButtonService {
  backButton$: Subscription;
  onNextClickClose = false;

  constructor(
    private readonly platform: Platform,
    private readonly modalController: ModalController,
    private readonly router: Router,
    private readonly utilsService: UtilsService,
    private readonly navController: NavController
  ) {}

  initBackButtonListener() {
    this.backButton$ = this.platform.backButton.subscribeWithPriority(999998, async () => {
      const isModalOpened = await this.modalController.getTop();
      if (isModalOpened) {
        this.modalController.dismiss();
        return;
      }
      if (CLOSING_APP_URLS.includes(this.router.url)) {
        if (this.onNextClickClose) {
          navigator['app'].exitApp();
        } else {
          this.onNextClickClose = true;
          this.utilsService.showToast('Press again to close the app', 'warning', 2500);
          this.onNextClickClose = false;
        }
        return;
      }
      this.navController.pop();
    });
  }

  removeListener() {
    this.backButton$.unsubscribe();
  }
}
